import { Component, Input } from '@angular/core';

import { SedsLoadersCoreModeOptions } from '../../seds-loaders/seds-loaders-core/enums/seds-loaders-mode-options.enum';
import { SedsLoadersCoreModeOptionsType } from '../../seds-loaders/seds-loaders-core/types/seds-loaders-mode-options.type';
import { SedsLoadersCoreTypeOptions } from '../../seds-loaders/seds-loaders-core/enums/seds-loaders-type-options.enum';

@Component({
    selector: 'seds-loaders-bar',
    templateUrl: './seds-loaders-bar.component.html',
    styleUrls: [],
    standalone: false
})
export class SedsLoadersBarComponent {
  @Input() current = 0;
  @Input() mode: SedsLoadersCoreModeOptionsType | SedsLoadersCoreModeOptions = SedsLoadersCoreModeOptions.INDETERMINATE;
  @Input() percentage = false;
  @Input() total = 0;
  type: SedsLoadersCoreTypeOptions = SedsLoadersCoreTypeOptions.PROGRESS_BAR;
}
